// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.znB9sv {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.LKlwb5 {
  flex: 1;
  min-width: 250px;
}

.NDKlYj {
  color: var(--icon-neutral-medium);
  width: 16px;
  height: 16px;
}

.yGl9lf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-0-5);
  margin: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--icon-neutral-stronger);
}

.IN83sc {
  width: 16px;
  height: 16px;
}

.sgOt_P {
  display: flex;
  gap: var(--spacing-1);
  align-items: center;
}

.lCOz8Y {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background-color: #f59e0b;
  color: white;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.lCOz8Y:hover {
  background-color: #d97706;
}

.lCOz8Y.OpDqDn {
  background-color: #1d4ed8;
  border-color: #3b82f6;
}

.lCOz8Y:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryFilters/BeneficiaryFilters.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.searchContainer {\n  flex: 1;\n  min-width: 250px;\n}\n\n.searchIcon {\n  color: var(--icon-neutral-medium);\n  width: 16px;\n  height: 16px;\n}\n\n.clearButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-0-5);\n  margin: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--icon-neutral-stronger);\n}\n\n.clearIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.filterContainer {\n  display: flex;\n  gap: var(--spacing-1);\n  align-items: center;\n}\n\n.newEmployeesTag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  background-color: #f59e0b;\n  color: white;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.newEmployeesTag:hover {\n  background-color: #d97706;\n}\n\n.newEmployeesTag.active {\n  background-color: #1d4ed8;\n  border-color: #3b82f6;\n}\n\n.newEmployeesTag:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `znB9sv`,
	"searchContainer": `LKlwb5`,
	"searchIcon": `NDKlYj`,
	"clearButton": `yGl9lf`,
	"clearIcon": `IN83sc`,
	"filterContainer": `sgOt_P`,
	"newEmployeesTag": `lCOz8Y`,
	"active": `OpDqDn`
};
module.exports = ___CSS_LOADER_EXPORT___;
